import React, {Component} from 'react';


import './styles.scss';
import PropTypes from 'prop-types';

export default class Loader extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      message = '',
      isFetching = true,
      isFullscreen = false,
      style,
    } = this.props;

    if (!isFetching) {
      return null;
    }

    return (
      <div className={isFullscreen ? 'loading-overlay' : ''} style={style}>
        <div data-component={'Loader'}>
          <div className={'spinner'}>
            <div className={'dot1'}></div>
            <div className={'dot2'}></div>
          </div>
          {
            message.length > 0 && <div className={'message'}>{message}</div>
          }
        </div>
      </div>
    );
  }
}

Loader.propTypes = {
  message: PropTypes.string,
  isFetching: PropTypes.bool,
  isFullscreen: PropTypes.bool,
  style: PropTypes.object,
};
